<template>
  <v-container>
    <v-form :lazy-validation="true">
      <validation-observer ref="validationObserver" v-slot="{ invalid }">
        <h3>Applying as</h3>
        <v-row dense>
          <v-col>
            <validation-provider
              name="Applying as"
              v-slot="{ errors }"
              rules="required"
            >
              <v-select
                label="Applying as *"
                outlined
                v-model="application.participantType"
                :items="participantTypeValues"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col v-if="application.participantType === 'accompanyingPerson'">
            <validation-provider
              name="Name of the person"
              v-slot="{ errors }"
              rules="required"
            >
              <v-text-field
                outlined
                v-model="application.accompanyingPersonName"
                label="Name of the person *"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col v-if="application.participantType === 'presenter'">
            <validation-provider
              name="ID of accepted paper"
              v-slot="{ errors }"
              rules="required"
            >
              <v-text-field
                outlined
                v-model="application.paperId"
                label="ID of accepted paper (see paper management system Conftool): *"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col v-if="application.participantType === 'exhibitor'">
            <validation-provider
              name="Booth number"
              v-slot="{ errors }"
              rules="required"
            >
              <v-text-field
                outlined
                v-model="application.boothNumber"
                label="Booth number *"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
        </v-row>
        <h3>Invitee's Personal Information</h3>
        <v-row dense>
          <v-col cols="4">
            <v-text-field
              label="First name"
              outlined
              v-model="application.firstName"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              label="Middle name"
              outlined
              v-model="application.middleName"
            />
          </v-col>
          <v-col cols="4">
            <validation-provider
              name="Last Name"
              v-slot="{ errors }"
              rules="required"
            >
              <v-text-field
                label="Last name *"
                outlined
                v-model="application.lastName"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col cols="2">
            <v-text-field
              label="Academic title"
              outlined
              v-model="application.academicTitle"
            />
          </v-col>
          <v-col cols="5">
            <v-menu
              v-model="showBirthdate"
              :close-on-content-click="false"
              max-width="290"
              rounded="xl"
            >
              <template #activator="{ on, attrs }">
                <validation-provider
                  name="Birthdate"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <v-text-field
                    label="Birthdate *"
                    :value="$options.filters.formatDate(application.birthdate)"
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar"
                    :error-messages="errors"
                    outlined
                  />
                </validation-provider>
              </template>
              <v-date-picker
                v-model="application.birthdate"
                @change="showBirthdate = false"
                locale="de"
                first-day-of-week="1"
              />
            </v-menu>
          </v-col>
          <v-col cols="5">
            <validation-provider
              name="Place of birth"
              v-slot="{ errors }"
              rules="required"
            >
              <v-text-field
                label="Place of birth *"
                outlined
                v-model="application.placeOfBirth"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col :cols="application.gender === 'other' ? 4 : 6">
            <validation-provider
              name="Nationality"
              v-slot="{ errors }"
              rules="required"
            >
              <v-autocomplete
                label="Nationality *"
                outlined
                :items="nationalityValues"
                v-model="application.nationality"
                item-text="text"
                item-value="value"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col :cols="application.gender === 'other' ? 4 : 6">
            <validation-provider
              name="Gender"
              v-slot="{ errors }"
              rules="required"
            >
              <v-select
                label="Gender *"
                outlined
                v-model="application.gender"
                :items="genderValues"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col v-if="application.gender === 'other'" cols="4">
            <validation-provider
              name="Gender"
              v-slot="{ errors }"
              rules="required"
            >
              <v-text-field
                outlined
                v-model="application.genderOther"
                label="Gender *"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col :cols="application.travelDocument === 'other' ? 4 : 6">
            <validation-provider
              name="Travel document"
              v-slot="{ errors }"
              rules="required"
            >
              <v-select
                label="Travel document *"
                outlined
                :items="travelDocumentValues"
                v-model="application.travelDocument"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col v-if="application.travelDocument === 'other'" cols="4">
            <validation-provider
              name="Travel document"
              v-slot="{ errors }"
              rules="required"
            >
              <v-text-field
                outlined
                v-model="application.travelDocumentOther"
                label="Travel document *"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col :cols="application.travelDocument === 'other' ? 4 : 6">
            <validation-provider
              name="Number of travel document"
              v-slot="{ errors }"
              rules="required"
            >
              <v-text-field
                outlined
                v-model="application.travelDocumentNumber"
                label="Number of travel document *"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col cols="4">
            <v-menu
              v-model="showIssueDate"
              :close-on-content-click="false"
              max-width="290"
              rounded="xl"
            >
              <template #activator="{ on, attrs }">
                <validation-provider
                  name="Date of issue"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <v-text-field
                    label="Date of issue *"
                    :value="
                      $options.filters.formatDate(
                        application.travelDocumentDateOfIssue
                      )
                    "
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar"
                    :error-messages="errors"
                    outlined
                  />
                </validation-provider>
              </template>
              <v-date-picker
                v-model="application.travelDocumentDateOfIssue"
                @change="showIssueDate = false"
                locale="de"
                first-day-of-week="1"
              />
            </v-menu>
          </v-col>
          <v-col cols="4">
            <v-menu
              v-model="showValidUntil"
              :close-on-content-click="false"
              max-width="290"
              rounded="xl"
            >
              <template #activator="{ on, attrs }">
                <validation-provider
                  name="Valid until"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <v-text-field
                    label="Valid until *"
                    :value="
                      $options.filters.formatDate(
                        application.travelDocumentValidUntil
                      )
                    "
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar"
                    :error-messages="errors"
                    outlined
                  />
                </validation-provider>
              </template>
              <v-date-picker
                v-model="application.travelDocumentValidUntil"
                @change="showValidUntil = false"
                locale="de"
                first-day-of-week="1"
              />
            </v-menu>
          </v-col>
          <v-col cols="4">
            <validation-provider
              name="Issued by"
              v-slot="{ errors }"
              rules="required"
            >
              <v-text-field
                outlined
                v-model="application.travelDocumentIssuedBy"
                label="Issued by *"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
        </v-row>
        <h3>Travel Information</h3>
        <v-row dense>
          <v-col cols="4">
            <v-menu
              v-model="showDateOfFirstEntry"
              :close-on-content-click="false"
              max-width="290"
              rounded="xl"
            >
              <template #activator="{ on, attrs }">
                <validation-provider
                  name="Intended date of first entry"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <v-text-field
                    label="Intended date of first entry *"
                    :value="
                      $options.filters.formatDate(application.dateOfFirstEntry)
                    "
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar"
                    :error-messages="errors"
                    outlined
                  />
                </validation-provider>
              </template>
              <v-date-picker
                v-model="application.dateOfFirstEntry"
                @change="showDateOfFirstEntry = false"
                locale="de"
                first-day-of-week="1"
              />
            </v-menu>
          </v-col>
          <v-col cols="4">
            <v-menu
              v-model="showDateOfDeparture"
              :close-on-content-click="false"
              max-width="290"
              rounded="xl"
            >
              <template #activator="{ on, attrs }">
                <validation-provider
                  name="Intended date of departure"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <v-text-field
                    label="Intended date of departure *"
                    :value="
                      $options.filters.formatDate(application.dateOfDeparture)
                    "
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar"
                    :error-messages="errors"
                    outlined
                  />
                </validation-provider>
              </template>
              <v-date-picker
                v-model="application.dateOfDeparture"
                @change="showDateOfDeparture = false"
                locale="de"
                first-day-of-week="1"
              />
            </v-menu>
          </v-col>
          <v-col cols="4">
            <validation-provider
              name="Member state of first entry"
              v-slot="{ errors }"
              rules="required"
            >
              <v-autocomplete
                label="Member state of first entry *"
                outlined
                :items="countries"
                v-model="application.entryState"
                item-text="value"
                item-value="key"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col cols="4">
            <validation-provider
              name="Number of entries"
              v-slot="{ errors }"
              rules="required"
            >
              <v-select
                label="Number of entries *"
                outlined
                :items="numberOfEntriesValues"
                v-model="application.numberOfEntries"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col cols="4">
            <validation-provider
              name="Application for visa at"
              v-slot="{ errors }"
              rules="required"
            >
              <v-select
                label="Application for visa at *"
                outlined
                :items="visaApplicationTypeValues"
                v-model="application.visaApplicationType"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col cols="4">
            <validation-provider
              name="Office name and place"
              v-slot="{ errors }"
              rules="required"
            >
              <v-autocomplete
                outlined
                v-model="application.visaOfficeNameAndPlace"
                :items="visaOfficeValues"
                label="Office name and place *"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
        </v-row>
        <h3>Correspondence Information</h3>
        <v-row dense>
          <v-col cols="6">
            <v-text-field
              outlined
              v-model="application.companyUniversity"
              label="Company/University"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              outlined
              v-model="application.departmentInstitution"
              label="Department/Institution"
            />
          </v-col>
          <v-col cols="4">
            <validation-provider
              name="Address"
              v-slot="{ errors }"
              rules="required"
            >
              <v-text-field
                outlined
                v-model="application.address"
                label="Address *"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col cols="4">
            <validation-provider
              name="Zip/City"
              v-slot="{ errors }"
              rules="required"
            >
              <v-text-field
                outlined
                v-model="application.zipCity"
                label="Zip/City *"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col cols="4">
            <validation-provider
              name="Country"
              v-slot="{ errors }"
              rules="required"
            >
              <v-autocomplete
                label="Country *"
                outlined
                :items="countries"
                v-model="application.country"
                item-text="value"
                item-value="key"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col cols="4">
            <v-text-field outlined v-model="application.phone" label="Phone" />
          </v-col>
          <v-col cols="4">
            <validation-provider
              name="Email"
              v-slot="{ errors }"
              vid="originalEmail"
              rules="required|email|confirmed:@confirmationEmail"
            >
              <v-text-field
                ref="originalMail"
                v-model="application.email"
                label="Email *"
                required
                outlined
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="4">
            <validation-provider
              name="Email (confirmation)"
              v-slot="{ errors }"
              vid="confirmationEmail"
              rules="required|email|confirmed:@originalEmail"
            >
              <v-text-field
                v-model="confirmationEmail"
                label="Email (confirmation) *"
                required
                outlined
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="application.notes"
              label="Any other relevant information"
              outlined
            />
          </v-col>
        </v-row>
        <v-row dense>
          <v-checkbox outlined v-model="agb">
            <template #label>
              <div>
                I accept the
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <a
                      target="_blank"
                      :href="termsAndConditionsUrl"
                      @click.stop
                      v-on="on"
                    >
                      terms and conditions
                    </a>
                  </template>
                  Opens in new window
                </v-tooltip>
                *
              </div>
            </template>
          </v-checkbox>
        </v-row>
        <v-row class="my-n6 ml-n7" v-if="!didVerify">
          <v-col>
            <div id="mcaptcha__widget-container" />
          </v-col>
        </v-row>
        <v-card-actions class="mt-3 mb-n5">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="!agb || invalid"
            @click="submit"
            :loading="submitting"
          >
            APPLY
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-form>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="white--text headline primary" primary-title>
          {{ $t("confirmationDialog.title") }}
        </v-card-title>
        <v-card-text class="pa-md-4">
          Your request for a letter of invitation to ICSMGE2026 in Vienna has
          been successfully submitted. You will shortly receive an email with
          the corresponding letter of invitation.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="reload">
            {{ $t("confirmationDialog.buttonText") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  verificationResource,
  mcaptchaSettingsResource,
  visaApplicationResource,
} from "../api/resources";
import de from "../i18n/de.json";
import nationalityValues from "./nationalityValues";
import visaOfficeValues from "./visaOfficeValues";
import Vue from "vue";

export default {
  data: () => ({
    application: {
      participantType: "",
      accompanyingPersonName: "",
      paperId: "",
      boothNumber: "",
      firstName: "",
      middleName: "",
      lastName: "",
      academicTitle: "",
      birthdate: "",
      placeOfBirth: "",
      nationality: "",
      gender: "",
      genderOther: "",
      travelDocument: "",
      travelDocumentOther: "",
      travelDocumentNumber: "",
      travelDocumentDateOfIssue: "",
      travelDocumentValidUntil: "",
      travelDocumentIssuedBy: "",
      dateOfFirstEntry: "",
      dateOfDeparture: "",
      entryState: "",
      numberOfEntries: "",
      visaApplicationType: "",
      visaOfficeNameAndPlace: "",
      companyUniversity: "",
      departmentInstitution: "",
      address: "",
      zipCity: "",
      country: "",
      phone: "",
      email: "",
      notes: "",
    },
    confirmationEmail: "",
    participantTypeValues: [
      { text: "Participant", value: "participant" },
      { text: "Accompanying Person", value: "accompanyingPerson" },
      { text: "Presenter", value: "presenter" },
      { text: "Exhibitor", value: "exhibitor" },
    ],
    genderValues: [
      { text: "Male", value: "male" },
      { text: "Female", value: "female" },
      { text: "Other", value: "other" },
    ],
    travelDocumentValues: [
      { text: "Ordinary Passport", value: "ordinaryPassport" },
      { text: "Diplomatic Passport", value: "diplomaticPassport" },
      { text: "Service Passport", value: "servicePassport" },
      { text: "Other", value: "other" },
    ],
    numberOfEntriesValues: [
      { text: "Single Entry", value: "single" },
      { text: "Double Entry", value: "double" },
      { text: "Multiple Entries", value: "multiple" },
    ],
    visaApplicationTypeValues: [
      {
        text: "Embassy/Consulate",
        value: "embassyConsulate",
      },
      {
        text: "Joint application processing centre",
        value: "jointApplicationProcessingCentre",
      },
      {
        text: "Service Provider",
        value: "serviceProvider",
      },
      {
        text: "Commercial Agent",
        value: "commercialAgent",
      },
    ],
    nationalityValues: nationalityValues,
    visaOfficeValues: visaOfficeValues,
    dialog: false,
    agb: false,
    submitting: false,
    termsAndConditionsUrl: "",
    showBirthdate: false,
    showIssueDate: false,
    showValidUntil: false,
    showDateOfFirstEntry: false,
    showDateOfDeparture: false,
    didVerify: false,
  }),
  async mounted() {
    const captchaSettings = (await mcaptchaSettingsResource.get()).data;
    let config = {
      widgetLink: new URL(captchaSettings.widgetLink),
    };
    // eslint-disable-next-line no-undef
    new mcaptchaGlue.default(config);
  },
  created() {
    this.resetApplicationFields();
    this.termsAndConditionsUrl = window.termsAndConditionsUrl;
    /*
    this.application = {
      participantType: "participant",
      accompanyingPersonName: "Jane Doe",
      paperId: "P12345",
      boothNumber: "B12",
      firstName: "John",
      lastName: "Smith",
      academicTitle: "Dr.",
      birthdate: "1980-01-01",
      placeOfBirth: "Vienna",
      nationality: "AT",
      gender: "male",
      genderOther: "",
      travelDocument: "ordinaryPassport",
      travelDocumentOther: "",
      travelDocumentNumber: "A1234567",
      travelDocumentDateOfIssue: "2020-01-01",
      travelDocumentValidUntil: "2030-01-01",
      travelDocumentIssuedBy: "BH Testikus",
      dateOfFirstEntry: "2024-09-01",
      dateOfDeparture: "2024-09-10",
      entryState: "AT",
      numberOfEntries: "single",
      visaApplicationType: "embassyConsulate",
      visaOfficeNameAndPlace: "Vienna Embassy",
      companyUniversity: "TU Wien",
      departmentInstitution: "Civil Engineering",
      address: "Karlsplatz 13",
      zipCity: "1040 Vienna",
      country: "AT",
      phone: "+43 1 2345678",
      email: "john.smith@example.com",
      notes: "Test invitation letter data",
    };
    */
  },
  methods: {
    async submit() {
      this.errorMessage = null;

      if (!this.didVerify) {
        const verificationToken =
          document.getElementById("mcaptcha__token").value;
        if (!verificationToken) {
          return;
        }
        await verificationResource.post("", {
          token: verificationToken,
        });
      }
      this.didVerify = true;

      this.submitting = true;
      const toSubmit = { ...this.application };

      visaApplicationResource.post("", toSubmit, {
        headers: {
          "x-xsrf-token": Vue.$cookies.get("oegg-cms.csrf"),
        },
      });
      this.application = {};
      this.agb = false;
      this.resetApplicationFields();
      this.$refs.validationObserver.reset();
      this.dialog = true;
      this.submitting = false;
    },
    reload() {
      location.reload();
    },
    resetApplicationFields() {
      this.application = {
        participantType: "",
        accompanyingPersonName: "",
        paperId: "",
        boothNumber: "",
        firstName: "",
        middleName: "",
        lastName: "",
        academicTitle: "",
        birthdate: "",
        placeOfBirth: "",
        nationality: "",
        gender: "",
        genderOther: "",
        travelDocument: "",
        travelDocumentOther: "",
        travelDocumentNumber: "",
        travelDocumentDateOfIssue: "",
        travelDocumentValidUntil: "",
        travelDocumentIssuedBy: "",
        dateOfFirstEntry: "",
        dateOfDeparture: "",
        entryState: "",
        numberOfEntries: "",
        visaApplicationType: "",
        visaOfficeNameAndPlace: "",
        companyUniversity: "",
        departmentInstitution: "",
        address: "",
        zipCity: "",
        country: "",
        phone: "",
        email: "",
        notes: "",
      };
    },
  },
  computed: {
    countries() {
      return Object.keys(de.countries).map((countryKey) => {
        return {
          key: countryKey,
          value: this.$t(`countries.${countryKey}`),
        };
      });
    },
  },
};
</script>
